import React from "react";

import {
  SeparatorCircle,
  SeparatorLine,
  SeparatorWrap,
} from "./OrderDetailV2OrderData.style";

interface OrderDataSeparatorProps {
  color?: string;
}

export const OrderDataSeparator: React.FC<OrderDataSeparatorProps> = ({
  color,
}) => {
  return (
    <SeparatorWrap>
      <SeparatorCircle color={color} />
      <SeparatorLine />
      <SeparatorCircle color={color} />
    </SeparatorWrap>
  );
};
